export enum RangeEnum {
    DAY = "day",
    WEEK = "week",
    MONTH = "month",
    QUARTER = "quarter",
    YEAR = "year",
}

export enum ServerFilterEnum {
    ALL = "All",
    ONLY_64_BIT = "Only 64-Bit",
    ONLY_32_BIT = "Only 32-Bit",
}

export enum DataTypeFilterEnum {
    CHARACTERS = "Characters",
    LFMS = "LFMs",
}

export enum RaidTimerCharacterSortEnum {
    NAME = "Name",
    LEVEL = "Level",
    RECENT_RAID = "Most Recent Raid",
}
